<template>
  <div class="content">
    <div class="container-fluid">
      <b-button class="tier-btn" tag="button" :to="'../tier/'+i" v-for="i in 4" key=i> Tier {{i}}</b-button>
      <div class="row">
        <div class="col-xl-10 col-md-2 col-sm-1">
          <h4 class="card-title">Tier {{ tier  }} Vendors</h4>              
          <p class="card-category">This is the current list of Tier {{ tier }} Vendors. 
            If you don't see the metrics for your specific vendor, you can open an issue and start the process with us.</p>              
          <div slot="content">
            <enhanced-table class='small' :datalist="vendors"/>
          </div>
          </div>
      </div>
    </div>
  </div>  
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import axios from 'axios'

  import { colors, formatMoney, formatSimple, gitlab_issue_url } from 'src/globalVariables'
  import { setInterval } from 'timers';


  Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }
  
  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    created() {
      this.loadData()
      var vm = this
      setInterval(function(){
        vm.loadData()
      },vm.refresh_minutes*60*1000)

    },
    methods: {
      loadData: function(){
        var today = new Date();
        this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
        console.log('refreshing...',this.tier)
        axios
          .get('vendors/tier?tier='+this.tier)
          .then(response => (this.vendor_names =  response.data))
        return true
      },
    },
    watch: {
      vendor_names: function(){
        var vm=this
        this.vendors=[]
        this.vendor_names.forEach(function(v){
          vm.vendors.push({name:v, link:{text:'Join forces to have on dashboard',url:gitlab_issue_url+v.name, target:'_blank'}})
        })
      },
      tier: function(){
        this.loadData()
      }
    },
    computed: {
      
    },
    props: ['tier'],
    data () {
      return {
        tier:1,
        refresh_minutes: 30,
        last_update: '',
        colors: colors,
        vendors:[],
        vendor_names:[],
      }
    }
  }
</script>
<style scoped>

.tier-btn {
    border-color:darkseagreen;
    background-color: darkslategray;
    color:snow;
    margin: 6px;
    font-weight: bold;
    cursor: pointer;
}

</style>
